/**
 * Service de traduction utilisant l'API gratuite MyMemory.
 * @param {string} text - Le texte à traduire.
 * @param {string} from - Langue d'origine (ex: 'fr').
 * @param {string} to - Langue de destination (ex: 'en').
 * @returns {Promise<string>} - Le texte traduit.
 */
export async function translateText(text, from = 'fr', to = 'en') {
    if (!text || text.trim() === '') return '';

    try {
        // API MyMemory : langpair=fr|en
        const response = await fetch(
            `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=${from}|${to}`
        );

        if (!response.ok) throw new Error('Erreur réseau lors de la traduction');

        const data = await response.json();
        return data.responseData.translatedText || '';
    } catch (error) {
        console.error('Erreur traduction:', error);
        return '';
    }
}
